// extracted by mini-css-extract-plugin
export default {"container":"PeopleNavigation_container__u4Z12","buttons":"PeopleNavigation_buttons__kpuDm"};